import React from 'react'

import { DiffModal } from '@/components/layout/modals/DiffModal'

const PROMPT_SETTINGS = [
  { key: 'llm_model_id', label: 'AI Model' },
  { key: 'side', label: 'Transcript Side' },
  { key: 'first_x_minutes', label: 'First X Minutes' },
  { key: 'last_x_minutes', label: 'Last X Minutes' },
  { key: 'include_timestamps', label: 'Include Timestamps' },
  { key: 'silence_threshold_seconds', label: 'Silence Threshold (sec)' },
]

const PROMPT_TEXT_FIELDS = [
  { key: 'user_prompt', label: 'User Prompt' },
  { key: 'system_prompt', label: 'System Prompt' },
]

/**
 * Modal that shows what changed between two prompt versions.
 */
export const PromptDiffModal = ({ open, onClose, oldPrompt, newPrompt }) => (
  <DiffModal
    open={open}
    onClose={onClose}
    oldItem={oldPrompt}
    newItem={newPrompt}
    title="Prompt Changes"
    settingsToCompare={PROMPT_SETTINGS}
    textFieldsToCompare={PROMPT_TEXT_FIELDS}
    className="prompt-diff-modal"
  />
)
